<div class="fondo">
  <div class="error">404</div>
  <span class="info">The Page Doesn't Exist</span>
</div>
